import { isDate } from "es-toolkit/compat";

export function replaceEmptyStringsWithUndefined<T>(obj: T): T {
  if (obj === ("" as any)) {
    return undefined as any;
  }

  // don't replace array values with empty strings
  if (Array.isArray(obj)) {
    return obj.map((value) =>
      value === "" ? "" : replaceEmptyStringsWithUndefined(value)
    ) as any;
  }

  // anything that isn't an object or array does not need to be traversed
  if (typeof obj !== "object" || isDate(obj)) {
    return obj;
  }

  // since we explicity handle arrays above, its safe to assume only regular objects
  // made it this far
  const newObj = {} as T;
  for (const key in obj) {
    newObj[key] = replaceEmptyStringsWithUndefined(obj[key]);
  }
  return newObj;
}
